"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../../Layout");

var _Elements = require("../../Elements");

var _reactFeather = require("react-feather");

var _useToast = require("./useToast");

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toast = function Toast(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      title = _a.title,
      Icon = _a.icon,
      description = _a.description,
      id = _a.id,
      _c = _a.autoDelete,
      autoDelete = _c === void 0 ? true : _c,
      _d = _a.duration,
      duration = _d === void 0 ? 50000 : _d;
  var deleteToast = (0, _useToast.useToast)().deleteToast;
  var toastDispatch = (0, _context.useToastDispatch)();

  _react.default.useEffect(function () {
    var interval = setInterval(function () {
      autoDelete && toastDispatch({
        type: 'DELETE_TOAST',
        id: id
      });
    }, duration);
    return function () {
      clearInterval(interval);
    };
  }, [autoDelete, duration]);

  return _react.default.createElement(_Layout.Flex, {
    key: title,
    sx: {
      backgroundColor: 'primary',
      color: 'white',
      border: '2px solid transparent',
      transition: '.3s ease',
      borderRadius: '4px',
      width: '365px',
      height: 'auto',
      boxShadow: '0px 0px 5px rgba(0, 0, 0, .2)',
      marginBottom: '16px',
      position: 'relative',
      cursor: 'pointer',
      padding: 3,
      variant: "toaster.toast." + variant + ".root"
    }
  }, _react.default.createElement(_Layout.Box, {
    as: "button",
    onClick: function onClick() {
      return deleteToast(id);
    },
    sx: {
      border: 'none',
      backgroundColor: 'transparent',
      color: 'inherit',
      position: 'absolute',
      right: '4px',
      cursor: 'pointer',
      variant: "toaster.toast." + variant + ".close"
    }
  }, _react.default.createElement(_reactFeather.X, {
    size: "20"
  })), _react.default.createElement(_Layout.Flex, null, Icon && _react.default.createElement(_Layout.Box, {
    sx: {
      ml: '16px',
      color: 'inherit',
      variant: "toaster.toast." + variant + ".icon"
    }
  }, Icon), _react.default.createElement(_Layout.Box, null, _react.default.createElement(_Elements.Text, {
    sx: {
      fontWeight: 700,
      mb: 2,
      variant: "toaster.toast." + variant + ".title"
    }
  }, title), _react.default.createElement(_Elements.Text, {
    variant: "toaster.toast." + variant + ".description"
  }, description))));
};

var _default = Toast;
exports.default = _default;